module.exports = __webpack_public_path__ + "img/Frame 13@2x.a036f279.png";